import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuBills = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 10.001V21.001C20 22.1055 19.1046 23.001 18 23.001H6C4.89543 23.001 4 22.1055 4 21.001V3.00098C4 1.89641 4.89543 1.00098 6 1.00098H12L20 10.001ZM6 2.50098C5.72386 2.50098 5.5 2.72483 5.5 3.00098V21.001C5.5 21.2771 5.72386 21.501 6 21.501H18C18.2761 21.501 18.5 21.2771 18.5 21.001V10.751H14C12.4812 10.751 11.25 9.51976 11.25 8.00098V2.50098H6ZM12.75 8.00098C12.75 8.69133 13.3096 9.25098 14 9.25098H17.3271L12.75 4.10156V8.00098Z"
	})
});
export default SvgMenuBills;
